// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"_1OaMm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Wrappers/AddonsWrapper/AddonsWrapper.scss
// module id = 539
// module chunks = 0